// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1VeDy","error":"Textarea_error__3UMY_","readonly":"Textarea_readonly__1tiH7","disabled":"Textarea_disabled__R0zXz"};